import styled from "styled-components"
import Florin from "./Florin.svg"
import FlorinNew from "./Florin_new.svg"
import { LayoutConst } from "core"

export const FlorinIcon = styled.div<{
    newIcon?: boolean
    size?: number
    mobileSize?: number
    margin?: string
    white?: boolean
    black?: boolean
}>`
    background-image: url(${({newIcon}) => newIcon ? FlorinNew : Florin});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    filter: invert(${p => p?.white ? 0 : p?.black ? 1 : 0.67});
    height: ${p => p.size ? p.size * 16 : 16}px;
    width: ${p => p.size ? p.size * 16 : 16}px;
    margin: ${p => p.margin !== undefined ? p.margin : "8px"};

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        height: ${p => p.size ? p.size * 16 : 16}px;
        width: ${p => p.size ? p.size * 16 : 16}px;
        margin: 0;
        margin-left: 8px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        height: ${p => p.mobileSize ? p.mobileSize * 16 : 16}px;
        width: ${p => p.mobileSize ? p.mobileSize * 16 : 16}px;
        margin: 0;
        margin-left: 8px;
    }
`import styled from "styled-components"
import Florin from "./Florin.svg"
import FlorinNew from "./Florin_new.svg"
import { LayoutConst } from "core"

export const FlorinIcon = styled.div<{
    newIcon?: boolean
    size?: number
    mobileSize?: number
    margin?: string
    white?: boolean
    black?: boolean
}>`
    background-image: url(${({newIcon}) => newIcon ? FlorinNew : Florin});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    filter: invert(${p => p?.white ? 0 : p?.black ? 1 : 0.67});
    height: ${p => p.size ? p.size * 16 : 16}px;
    width: ${p => p.size ? p.size * 16 : 16}px;
    margin: ${p => p.margin !== undefined ? p.margin : "8px"};

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        height: ${p => p.size ? p.size * 16 : 16}px;
        width: ${p => p.size ? p.size * 16 : 16}px;
        margin: 0;
        margin-left: 8px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        height: ${p => p.mobileSize ? p.mobileSize * 16 : 16}px;
        width: ${p => p.mobileSize ? p.mobileSize * 16 : 16}px;
        margin: 0;
        margin-left: 8px;
    }
`